export const searchObjectToParams = (search: Record<string, unknown>): URLSearchParams =>
  new URLSearchParams(
    Object.entries(search)
      .filter(([, v]) => v !== undefined && v !== null)
      .map(([k, v]) => [k, String(v)])
  );

type UpdateParamInUrlBase = {
  pathname: string | null;
  searchParams: URLSearchParams | null;
};
export const updateParamInUrl = (key: string, value: string | undefined | null, options: UpdateParamInUrlBase) => {
  if (!options.pathname) {
    return '';
  }

  if (!options.searchParams) {
    return options.pathname;
  }

  const updatedSeachParams = new URLSearchParams(options.searchParams.toString());
  if (value) {
    updatedSeachParams.set(key, value);
  } else {
    updatedSeachParams.delete(key);
  }

  return `${options.pathname}?${updatedSeachParams}`;
};

//TODO: remove this after removing pages
export const parseQueryParam = (param: string | string[] | undefined) => (Array.isArray(param) ? param[0] : param);
